var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.rulesDraft
        ? _c("sc-form", {
            attrs: { rules: _vm.rulesDraft, form: _vm.quoteFreightComparison },
            on: { change: _vm.updateFields, submit: _vm.submit },
            scopedSlots: _vm._u([
              {
                key: "fields",
                fn: function(ref) {
                  var fields = ref.fields
                  return [
                    _c("sc-real-time-quotation"),
                    _vm._v(" "),
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        { staticClass: "column" },
                        [_c("sc-quote-rules", { attrs: { fields: fields } })],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("sc-basic-data", {
                      attrs: {
                        delivery_methods_added: _vm.delivery_methods_added,
                        showDraftLogistics: _vm.showDraftLogistics,
                        fields: fields
                      }
                    }),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        { staticClass: "column is-3" },
                        [
                          _c(
                            "sc-field",
                            { attrs: { label: "Métodos de entrega" } },
                            [
                              _c(
                                "sc-select",
                                {
                                  attrs: {
                                    placeholder:
                                      "Selecione um método de entrega"
                                  },
                                  model: {
                                    value: fields.delivery_method,
                                    callback: function($$v) {
                                      _vm.$set(fields, "delivery_method", $$v)
                                    },
                                    expression: "fields.delivery_method"
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: null } }, [
                                    _vm._v(
                                      "\n                Selecione um método de entrega\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.deliveryMethodListFilter, function(
                                    delivery_method
                                  ) {
                                    return _c(
                                      "option",
                                      {
                                        key: delivery_method.id,
                                        domProps: { value: delivery_method }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(delivery_method.name) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "buttons has-addons" },
                        [
                          _c("sc-button", {
                            staticClass: "button-add",
                            attrs: {
                              theme: "primary",
                              text: "Adicionar",
                              disabled: !fields.delivery_method
                            },
                            on: {
                              click: function($event) {
                                _vm.addDeliveryMethod(
                                  fields.delivery_method,
                                  fields.origin_zip_code
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("sc-button", {
                            staticClass: "button-add",
                            attrs: {
                              theme: "default",
                              disabled: _vm.listContract.length === 0,
                              text: "Limpar métodos de entrega"
                            },
                            on: {
                              click: function($event) {
                                _vm.deleteDeliveryMethods()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.listContract, function(dm) {
                      return _c("div", { key: dm.id, staticClass: "columns" }, [
                        _c(
                          "div",
                          { staticClass: "column" },
                          [
                            _c("sc-logistic-contracts", {
                              attrs: { delivery: dm }
                            })
                          ],
                          1
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c("sc-volume", { attrs: { fields: fields } })
                  ]
                }
              },
              {
                key: "actions",
                fn: function(ref) {
                  var isValid = ref.isValid
                  return [
                    _c("sc-button", {
                      attrs: { theme: "default", text: "Voltar" },
                      on: { click: _vm.backUrl }
                    }),
                    _vm._v(" "),
                    _c("sc-button", {
                      attrs: {
                        type: "submit",
                        theme: "primary",
                        text: "Calcular"
                      }
                    })
                  ]
                }
              }
            ])
          })
        : _vm._e(),
      _vm._v(" "),
      _c("sc-quote-test-return", { attrs: { fields: _vm.newFields } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5dc5cd4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dc5cd4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-logistic-draft-test/ScLogisticDraftTest.vue
// module id = null
// module chunks = 